import { Container } from "@mui/material";
import { Controller } from "react-scrollmagic";
import RoadmapItem from "../../components/RoadmapItem";
import SectionTitle from "../../components/SectionTitle";
import { ROADMAP } from "../../constants";

const RoadMapSection = () => {
  return (
    <section
      id="roadmap"
      style={{
        width: "100%",
      }}
    >
      <Container>
        <SectionTitle title="ROADMAP"></SectionTitle>
        <Controller>
          {ROADMAP.map((item, index) => (
            <RoadmapItem
              key={item.title}
              title={item.title}
              content={item.content}
              duration={item.height}
              mobileDuration={item.mobileHeight}
              isLast={ROADMAP.length === index + 1}
            ></RoadmapItem>
          ))}
        </Controller>
      </Container>
    </section>
  );
};

export default RoadMapSection;
